export const SET_AUFTRAGSSTATI = "setAuftragstati"
export const SET_BUCHUNGSSTATI = "setBuchungsstati"
export const SET_ZAHLUNGSVERBINDUNGEN = "setZahlungsverbindungen"
export const SET_KONTEN = "setKonten"
export const SET_ZAHLUNGSPLAENE = "setZahlungsplaene"
export const SET_ZAHLUNGSKONDITIONEN = "setZahlungskonditionen"
export const SET_AUFTRAGSQUELLEN = "setAuftragsquellen"
export const SET_MEHRWERTSTEUERCODES = "setMehrwertsteuerCodes"
export const SET_KOSTENSTELLEN = "setKostenstellen"
